
import { useState } from 'react';
import { ImplantListGroupItem } from '../components/ImplantCard';
import Spinner from "../components/Spinner";
import { labelSearch } from '../services';

const Passport = () => {

    const [lines, setLines] = useState([]);

    const [submitting, setSubmitting] = useState(false);

    const onSubmitClick = () => {
        setSubmitting(true);
        createPassport(lines);
    };

    const onPassportLineChange = line => {
        setLines([line]);
    };

    return <>
        <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
                <li className="breadcrumb-item active" aria-current="page">Passport Generator</li>
            </ol>
        </nav>
        <div className="container passport-form-container" style={{ "minHeight": "500px" }}>
            <PassportLine onChange={onPassportLineChange} />

            {lines.length ?

                <div className="passport-cta-container">
                    <button onClick={onSubmitClick} className="btn btn-primary btn-lg rounded-pill btn-block" disabled={submitting} foo="bar" data-loading={submitting} {...{ "loading": submitting }}>Create Passport <div class="spinner spinner-bg "></div></button>
                </div>
                : ''}
            {/* <ImplantSelector /> */}
        </div>
    </>;
};


const PassportLine = props => {

    var currentDate = (new Date()).toISOString().substr(0, 10);

    const [labelFile, setLabelFile] = useState(undefined);
    const [implantModelCandidates, setImplantModelCandidates] = useState(undefined);

    const [implantModel, setImplantModel] = useState(undefined);

    const [metadata, setMetadata] = useState({ placement_date: currentDate });

    const [searchingLabel, setSearchingLabel] = useState(false);

    const onLabelChange = async (event) => {
        const file = Object(event.currentTarget.files)[0];
        setLabelFile(file);

        const newMetadata = {
            ...metadata,
            labelFile: file
        };

        setMetadata(newMetadata);

        setSearchingLabel(true);

        const resp = await labelSearch(file);

        setSearchingLabel(false);
        setImplantModelCandidates(resp.implant_models);
        setMetadata({ ...metadata, labelFile: file, reference: resp.reference, lot: resp.lot });
    };

    const onImplantClick = (implantModel) => {
        setImplantModel(implantModel);


        const newMetadata = {
            ...metadata,
            implant_model: implantModel.id
        };

        setMetadata(newMetadata);

        props.onChange(newMetadata);
    };

    const onMetadataFieldChanged = (field, value) => {
        const newMetadata = {
            ...metadata,
            [field]: value
        };

        setMetadata(newMetadata);
        props.onChange(newMetadata);
    };

    const onSiteNumberChanged = e => {
        const newMetadata = {
            ...metadata,
            site_number: e.target.value
        };

        setMetadata(newMetadata);
        props.onChange(newMetadata);
    };

    const onPlacementDateChanged = e => {
        const newMetadata = {
            ...metadata,
            placement_date: e.target.value
        };

        setMetadata(newMetadata);
        props.onChange(newMetadata);
    };


    const onEditModelClick = () => {
        setImplantModel(undefined);
    };

    const labelBlob = labelFile ? URL.createObjectURL(labelFile) : '';

    const implantModelImgUrl = implantModel && implantModel.main_image_url;


    return <div className="row">

        {!labelFile ?
            <div className="col-md-6 offset-md-3">
                <label className="btn btn-primary btn-lg rounded-pill btn-block">
                    Submit implant label <i className="fas fa-camera"></i> <input type="file" hidden onChange={onLabelChange} />
                </label> </div> : ''}

        {labelFile ? <>

            <div className="col-md-4">
                <img src={labelBlob} className="img-thumbnail label-thumbnail" alt="label" />
            </div>



            <div className="col-md-6">

                {!labelFile ? <label className="btn btn-primary btn-lg rounded-pill btn-block">
                    Submit implant label <i className="fas fa-camera"></i> <input type="file" hidden onChange={onLabelChange} />
                </label> : ''}


                {labelFile && searchingLabel ? <Spinner /> : ''}

                {!implantModel && implantModelCandidates ?
                    <><p style={{ marginTop: "10px" }}>Confirm implant model:</p>
                        <div className="list-group">
                            {!implantModel && implantModelCandidates ? implantModelCandidates.map(item => {
                                return <ImplantListGroupItem implant={item} onClick={() => onImplantClick(item)} />;
                            }) : ''
                            }
                        </div>
                    </> : ''}

                {implantModel ? <>
                    <div className="block-with-inline-img" style={{ margin: "10px 0" }}>
                        {implantModelImgUrl ? <div className="img-container"><img src={implantModelImgUrl} className="implant-image-thumbnail" /></div> : ''}
                        {implantModel.brand_name} {implantModel.name}  <button className='btn btn-link' onClick={onEditModelClick}><span className="oi oi-pencil" aria-hidden="true"></span></button>
                    </div>
                    <div>
                        <div className="form-group row">
                            <label className="col-form-label col-md-4 col-sm-6">Reference</label>
                            <div className="field-col col-md-8 col-sm-6">
                                <input onChange={(e) => onMetadataFieldChanged("reference", e.target.value)} defaultValue={metadata.reference} className="textinput textInput form-control" />
                            </div>
                        </div>

                        <div className="form-group row">
                            <label className="col-form-label col-md-4 col-sm-6">Lot</label>
                            <div className="field-col col-md-8 col-sm-6">
                                <input onChange={(e) => onMetadataFieldChanged("lot", e.target.value)} defaultValue={metadata.lot} className="textinput textInput form-control" />
                            </div>
                        </div>

                        <div className="form-group row">
                            <label className="col-form-label col-md-4 col-sm-6">Site number</label>
                            <div className="field-col col-md-8 col-sm-6">
                                <input type="number" onChange={(e) => onMetadataFieldChanged("site_number", e.target.value)} className="textinput textInput form-control" />
                            </div>
                        </div>

                        <div className="form-group row">
                            <label className="col-form-label col-md-4 col-sm-6">Placement date</label>
                            <div className="field-col col-md-8 col-sm-6">
                                <input type="date" onChange={(e) => onMetadataFieldChanged("placement_date", e.target.value)} defaultValue={currentDate} className="textinput textInput form-control" />
                            </div>
                        </div>

                        <label className="btn btn-light rounded-pill btn-block">
                            <i className="fas fa-plus"></i> Attach radiograph(s) <input type="file" hidden onChange={onLabelChange} />
                        </label>
                    </div>
                </> : ''}

            </div>
        </> : ''}

    </div>;
};





async function createPassport(lines) {
    const baseUrl = "/api/v1/passports/";

    const formData = new FormData();

    var csrftoken = window.btutils.getCookie('csrftoken');

    formData.append('csrfmiddlewaretoken', csrftoken);
    const response = await fetch(baseUrl, {
        method: 'POST',
        body: formData,
        // headers: headers,
    });
    const passportData = await response.json();

    await Promise.all(lines.map(line => createPassportLine(passportData.id, line)));

    const generateResp = await fetch(`${baseUrl}${passportData.id}/generate/`, {
        method: 'POST',
        credentials: "include",
        headers: {
            "X-CSRFToken": window.btutils.getCookie("csrftoken"),
        }
    });
    window.location.href = `/en/passport/${passportData.id}`;
}


async function createPassportLine(passportId, line) {
    const baseUrl = "/api/v1/passportlines/";

    const formData = new FormData();
    var csrftoken = window.btutils.getCookie('csrftoken');

    formData.append('label', line.labelFile);
    formData.append('passport', passportId);
    formData.append('implant_model', line.implant_model);
    if (line.site_number) {
        formData.append('site_number', line.site_number);
    }

    if (line.placement_date) {
        formData.append('placement_date', line.placement_date);
    }

    if (line.reference) {
        formData.append('reference', line.reference);
    }

    if (line.lot) {
        formData.append('lot', line.lot);
    }


    formData.append('csrfmiddlewaretoken', csrftoken);

    const response = await fetch(baseUrl, {
        method: 'POST',
        body: formData,
    });
    const data = await response.json();
    return data.id;
}


export default Passport;